import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=14452f6e"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=14452f6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports